import LOGO_LEAN_TECH from './images/logo-leantech.png';
import BELL_SOLID from './icons/bell-solid.svg';
import CHART_LINE from './icons/chart-line-solid.svg';
import FUTBOL from './icons/futbol-regular.svg';
import MEDAL_SOLID from './icons/medal-solid.svg';
import MONEY_BILL_WAVE from './icons/money-bill-wave-solid.svg';
import STORE_ALT from './icons/store-alt-solid.svg';
import TSHIRT from './icons/tshirt-solid.svg';
import USERS from './icons/users-solid.svg';
import USER_CONG from './icons/user-cog-solid.svg';
import DUMBBELL from './icons/dumbbell-solid.svg';
import BARS from './icons/bars-solid.svg';
import LOGO from './icons/logo.svg';
import COG from './icons/cog-solid.svg';
import PLUS from './icons/plus-solid.svg';
import CALENDAR from './icons/calendar-day-solid.svg';
import CLIPBOARD from './icons/clipboard-list-solid.svg';
import ENVELOPE from './icons/envelope-solid.svg';
import LIST_OL from './icons/list-ol-solid.svg';
import USER_PLUS from './icons/user-plus-solid.svg';
import MINIMUS from './icons/minus-circle-solid.svg';
import PERSON from './images/loginImage.png';
import USER from './icons/user-solid.svg';
import EMAIL from './icons/email-solid.svg';
import VISIBILITY from './icons/visibility.svg';
import VISIBILITY_OFF from './icons/visibility-off.svg';

export default {
    LOGO_LEAN_TECH,
    BELL_SOLID,
    CHART_LINE,
    FUTBOL,
    MEDAL_SOLID,
    MONEY_BILL_WAVE,
    STORE_ALT,
    TSHIRT,
    USERS,
    USER_CONG,
    DUMBBELL,
    BARS,
    LOGO,
    COG,
    PLUS,
    CALENDAR,
    CLIPBOARD,
    ENVELOPE,
    LIST_OL,
    USER_PLUS,
    MINIMUS,
    PERSON,
    USER,
    EMAIL,
    VISIBILITY,
    VISIBILITY_OFF
};
